const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api` ;

const handleResponse = async (res) => {
  if (!res.ok) {
    const error = await res.text();
    throw new Error(error || 'Network response was not ok');
  }
  return res.json();
};

// Get all payments
export const getAllPayments = async () => {
  const res = await fetch(`${API_BASE_URL}/paymentService/admin/payments`);
  return handleResponse(res);
};

// Get payment by ID
export const getPaymentById = async (paymentId) => {
  const res = await fetch(`${API_BASE_URL}/paymentService/admin/payments/${paymentId}`);
  return handleResponse(res);
};

// Update payment status
export const updatePaymentStatus = async (paymentId, status) => {
  const res = await fetch(`${API_BASE_URL}/paymentService/admin/status/${paymentId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status }),
  });
  return handleResponse(res);
};

// Delete payment
export const deletePayment = async (paymentId) => {
  const res = await fetch(`${API_BASE_URL}/paymentService/admin/payments/${paymentId}`, {
    method: 'DELETE',
  });
  return handleResponse(res);
};

// Export data as CSV
export const exportPaymentsAsCSV = async (filters = {}) => {
  const url = new URL(`${API_BASE_URL}/paymentService/admin/payments/export`);
  Object.keys(filters).forEach(key => url.searchParams.append(key, filters[key]));

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    const error = await res.text();
    throw new Error(error || 'CSV export failed');
  }
  return res.blob();
};
